import { render, staticRenderFns } from "./newer-redbag.vue?vue&type=template&id=7cf10ff9&scoped=true&"
import script from "./newer-redbag.vue?vue&type=script&lang=js&"
export * from "./newer-redbag.vue?vue&type=script&lang=js&"
import style0 from "./newer-redbag.vue?vue&type=style&index=0&id=7cf10ff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf10ff9",
  null
  
)

export default component.exports